import httpClient from '@/api/httpClient';

const BASE_URL = '/api/fees';

const calculateCharges = (provider, type, orderId) => httpClient.get(`${BASE_URL}/calculate/${provider}/${type}/${orderId}`);

export {
  calculateCharges
};
